<script>
  export let scale = 1;
  export let color = "#323232";
</script>

<svg width={12 * scale} height={12 * scale} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill={color} d="M1.66873 11.1188L0.881226 10.3313L5.21248 6.00001L0.881226 1.66876L1.66873 0.881256L5.99998 5.21251L10.3312 0.881256L11.1187 1.66876L6.78748 6.00001L11.1187 10.3313L10.3312 11.1188L5.99998 6.78751L1.66873 11.1188Z" />
</svg>
